module.exports = __webpack_public_path__ + "media/B67.571e3af6.mp3";